export var NetworkStatus;

(function (NetworkStatus) {
  NetworkStatus["loading"] = "loading";
  NetworkStatus["fetchMore"] = "fetchMore";
  NetworkStatus["ready"] = "ready";
  NetworkStatus["error"] = "error";
})(NetworkStatus || (NetworkStatus = {}));

export function isRequestInFlight(networkStatus) {
  return [NetworkStatus.loading, NetworkStatus.fetchMore].includes(networkStatus);
}
//# sourceMappingURL=networkStatus.js.map